import '@babel/polyfill'
import bean from 'bean'
import Vue from 'vue'

import store from '@/store'
import router from '@/router'
import * as EventBus from '@/util/event/event-bus'

import App from '@/App.vue'

Vue.config.productionTip = false

Vue.use(EventBus)

const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

if (process.env.NODE_ENV === 'development') {
  global.Vue = Vue
  global.$app = app
  global.$store = store
  global.$router = router
}

bean.one(window, 'load', () => {
  if (/trident/i.test(window.navigator.userAgent)) {
    document.body.classList.add('ie')
  }

  function updateTitle (route) {
    const title = [ 'Cracker Jack', route.meta.title ]
      .filter(Boolean)
      .join(' - ')

    document.title = title
  }

  function sendPageView (route) {
    if (!window.gtag) return

    window.gtag('config', 'UA-113093403-70', {
      'page_path': route.path,
      'page_title': document.title,
    })
  }

  updateTitle(router.currentRoute)
  sendPageView(router.currentRoute)

  router.afterEach((to, from) => {
    updateTitle(to)
    sendPageView(to)
  })
})
